<template>
  <div class="outcome-container">
    <h2 class="title">{{ getTranslatedText("Place your bet") }}</h2>
    <Title
      v-if="drawDate"
      class="outcome-draw-date"
      :title="renderDateText(drawDate)"
      :titleOption="`- ${renderHour(drawDate)}`"
    />
    <Title
      prefix="01"
      :title="getTranslatedText('Number of balls')"
      @click="collapsed = false"
    />
    <div class="list-select">
      <div class="row" v-for="(row, rowIndex) in rows" :key="rowIndex">
        <div
          class="select-item"
          :class="{
            'select-item__selected': item.pick === selectedMarketOption,
            collapsed: collapsed && item.pick !== selectedMarketOption,
          }"
          v-for="(item, index) in row"
          :key="index"
          @click="selectOutcome(item)"
        >
          <p class="select-item__title">
            <i class="bi bi-check-circle-fill select__icon"></i>
            {{ getTranslatedText(item.name) }}
          </p>
          <p class="select-item__odds">{{ formatPrice(item.odds) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utilsMixins from "@/mixins/function-utils";
import Title from "@/components/common/title/index.vue";
import languageMixins from "@/mixins/language-mixins";
import EventBus from "@/utils/EventBus";

export default {
  mixins: [languageMixins, utilsMixins],
  components: { Title },
  props: {
    outcomes: Array,
    drawDate: String,
    outcomeSelected: Object,
  },
  data() {
    return {
      rows: [],
      itemsPerRow: 3,
      selectedMarketOption: 1,
      collapsed: false,
    };
  },
  created() {
    this.handleShowOutCome(this.outcomes);
    EventBus.on("onMaxPickReached", this.handleOnMaxPickReached);
  },

  unmounted() {
    EventBus.off("onMaxPickReached", this.handleOnMaxPickReached);
  },

  watch: {
    outcomes: {
      handler(newOutcomes) {
        this.handleShowOutCome(newOutcomes);
      },
      deep: true,
    },
    outcomeSelected: {
      handler(newOutcome) {
        if (newOutcome) {
          this.selectedMarketOption = newOutcome.pick;
          this.$emit("selectOutcome", newOutcome);
          EventBus.emit("selected-outcome", newOutcome);
        }
      },
      deep: true,
    },
  },
  methods: {
    handleOnMaxPickReached() {
      const arr = [...this.outcomes];
      const sorted = arr.sort((a, b) => +a.pick - +b.pick);
      const nextOutcome = sorted.find(
        (item) => +item.pick > +this.selectedMarketOption
      );

      if (nextOutcome) {
        this.selectOutcome(nextOutcome, false, false);
      }
    },

    handleShowOutCome(outcomes) {
      this.rows = [];
      for (let i = 0; i < outcomes.length; i += this.itemsPerRow) {
        this.rows.push(outcomes.slice(i, i + this.itemsPerRow));
      }

      if (outcomes.length > 0) {
        const pick3 = outcomes.find((item) => item.pick === "3");
        if (pick3) {
          this.selectOutcome(outcomes[0], false);
          this.selectOutcome(pick3, false);
        } else {
          this.selectOutcome(outcomes[0], false);
        }
      }
    },
    selectOutcome(outcome, isUserClick = true, clearPicks = true) {
      if (isUserClick) {
        this.collapsed = true;
      }

      if (this.selectedMarketOption === outcome.pick) {
        this.collapsed = false;
        return;
      }

      this.selectedMarketOption = outcome.pick;
      if (clearPicks) {
        EventBus.emit("clear-picks");
      }
      this.$emit("selectOutcome", outcome);
      EventBus.emit("selected-outcome", outcome);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/public/scss/components/coupons/outcome.scss";
.outcome-container {
  padding: 10px 0;
  .title {
    color: var(--color-text-4);
    text-transform: capitalize;
  }

  .outcome-draw-date {
    border-bottom: none;

    ::v-deep(.title-container__title) {
      font-weight: normal;
      span {
        font-weight: bold;
      }

      &::before {
        content: unset;
      }
    }
  }

  .select-item__selected .select__icon {
    color: var(--color-text-4) !important;
  }

  .select-item {
    transition: all 0.3s;
  }

  @media (max-width: 576px) {
    .select-item.collapsed {
      transition: none;
      opacity: 0;
      height: 0px;
      padding: 0px !important;
      overflow: hidden;
      border: 0 !important;
    }

    .select-item__selected {
      padding: 5px !important;
      position: relative;
    }
  }
}
</style>
